<form action="{{action}}" method="post" (submit)="sendSubmit()" [class.server-side]="isServer">
  <ng-content></ng-content>
</form>